'use client';

/* Lazy wrapper around BookingEngineScene. The heavy implementation lives in
 * ./BookingEngineScene.impl. See ./lazyScene.js for why scenes are lazy-mounted. */

import {lazyScene} from './lazyScene';

const BookingEngineScene = lazyScene(() => import('./BookingEngineScene.impl'), {minH: 460});

export default BookingEngineScene;
